module.exports = __webpack_public_path__ + "themes/fq/sprite/win-frame.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/win-frame.json
// module id = 102
// module chunks = d-game